import React, { Component } from "react";
import { SubAppConfig } from "../../../../../reducers/subAppsConfig.reducer";
import _ from "lodash";

import "./TopbarItem.component.scss";

export interface TopbarItemProps {
    subAppConfig: SubAppConfig;
    onSelect: () => any;
    selected: boolean;
}

class TopbarItem extends Component<TopbarItemProps, {}> {
    static defaultProps: TopbarItemProps = {
        subAppConfig: null,
        onSelect: null,
        selected: false
    };

    render() {
        let itemClass = "topbar-item";
        if (this.props.selected) {
            itemClass += " topbar-item-selected";
        }

        return (
            <div className={itemClass} onClick={this.props.onSelect}>
                <div className="topbar-item-desc">
                    {this.props.subAppConfig.title}
                </div>
            </div>
        );
    }
}

export default TopbarItem;
